export default __webpack_public_path__ + "static/media/78.a02066c2.png";